module.exports = __webpack_public_path__ + "img/footprints - aragorn.eed128ee.svg";